// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LIST_OF_RECENT_BLOG_ARTICLES_SHOW_MORE = "V\u00edce nov\u00fdch \u010dl\u00e1nk\u016f...";
export const LOAD_ERROR_MESSAGE = "Nepoda\u0159ilo se na\u010d\u00edst obsah";
export const STROLLEROPEDIA_NEW_ARTICLES = "Nejnov\u011bj\u0161\u00ed \u010dl\u00e1nky";
